export default __webpack_public_path__ + "static/media/test-ok.90bc9d29.svg";